import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledWrapper = styled.div`
	position: relative;
	width: 60px;
	height: 60px;
`;

const StyledContainer = styled.div<{
	$isOpen: boolean;
	$isInventory?: boolean;
	$disabled?: boolean;
	$isPlaceholder?: boolean;
}>`
	position: absolute;
	bottom: 0;
	left: 0;
	width: 60px;
	border-radius: 10px;
	background-color: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	transition:
		height 0.3s ease,
		background-color 0.3s ease;
	overflow: hidden;
	display: flex;
	flex-direction: column-reverse;
	align-items: center;
	gap: 10px;
	padding-bottom: ${({ $isInventory }) => ($isInventory ? '3px' : '9px')};

	${({ $isOpen, $isInventory, $disabled, $isPlaceholder }) =>
		!$isOpen &&
		!$disabled &&
		css`
			&:hover {
				background-color: #ffffff;
				cursor: pointer;

				${($isInventory || $isPlaceholder) &&
				css`
					img {
						filter: invert(1);
						opacity: 1;
					}
				`}
			}
		`}
`;

const StyledItemContainer = styled.div<{
	$isSelected: boolean;
	$disabled?: boolean;
	$isInventory?: boolean;
	$transparent?: boolean;
	$inventoryInactive?: boolean;
}>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: ${({ $isInventory }) => ($isInventory ? '50px' : '40px')};
	height: ${({ $isInventory }) => ($isInventory ? '50px' : '40px')};
	min-height: ${({ $isInventory }) => ($isInventory ? '50px' : '40px')};
	border-radius: ${({ $isInventory }) => ($isInventory ? '50px' : '40px')};
	background-color: transparent;
	border: 1px solid transparent;

	transition:
		background-color 0.3s ease,
		border 0.3s ease;

	${({ $isSelected, $disabled }) =>
		!$isSelected &&
		!$disabled &&
		css`
			&:hover {
				background-color: rgba(255, 255, 255, 0.1);
				border: 1px solid rgba(255, 255, 255, 0.25);
				cursor: pointer;
			}
		`}

	img {
		width: 30px;
		height: 30px;
		user-select: none;
		pointer-events: none;
		opacity: ${({ $disabled, $transparent, $inventoryInactive }) =>
			$disabled ? 0.25 : $transparent || $inventoryInactive ? 0.5 : 1};
		transition:
			filter 0.3s ease,
			opacity 0.3s ease;
	}
`;

const StyledCount = styled.div`
	position: absolute;
	top: -10px;
	left: 50%;
	transform: translateX(-50%);
	z-index: 10;
	display: flex;
	align-items: center;
	justify-content: center;
	width: auto;
	height: 20px;
	padding: 0 6px;
	background-color: #ffffff;
	border-radius: 20px;
	pointer-events: none;
	transition: opacity 0.3s ease;

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #000000;
	}
`;

export { StyledContainer, StyledCount, StyledItemContainer, StyledWrapper };
